var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      loading: _vm.branchListLoading,
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1)], 1)], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Current FY Sales ")]), _c("count-to", {
    key: _vm.totalFySales,
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.totalFySales,
      duration: 2600
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Current FY Payments ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.totalFyPayment,
      duration: 2600
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: "order/list/?status=Order Confirmed" + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Total Pending Orders ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.totalPendingOrders,
      duration: 2600
    }
  })], 1)])])], 1)], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Current Month Sale ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.currentMonthSales,
      duration: 2600
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Current Month Payments ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.currentMonthPayments,
      duration: 2600
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Previous Month Sales ")]), _c("count-to", {
    key: _vm.previousMonthSales,
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.previousMonthSales,
      duration: 2600
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Previous Month Payments ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.previousMonthPayments,
      duration: 2600
    }
  })], 1)])])], 1)], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/order/list?startDate=${_vm.currentDateRange.start}&endDate=${_vm.currentDateRange.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Daily Order Value ")]), _c("count-to", {
    key: _vm.dailyOrderValue,
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.dailyOrderValue,
      duration: 2600
    }
  })], 1)])])], 1)], 1), _c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v(" Orders ")]), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, _vm._l(_vm.orderStatus, function (status) {
    return _c("el-col", {
      key: status.status,
      staticClass: "card-panel-col",
      attrs: {
        xs: 12,
        sm: 6,
        lg: 4
      }
    }, [_c("router-link", {
      attrs: {
        to: "/order/list?status=" + status.status + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
      }
    }, [_c("div", {
      staticClass: "card-panel"
    }, [_c("div", {
      staticClass: "card-panel-description"
    }, [_c("div", {
      staticClass: "card-panel-text"
    }, [_vm._v(" " + _vm._s(status.status) + " ")]), _c("count-to", {
      staticClass: "card-panel-num",
      attrs: {
        "start-val": 0,
        "end-val": status.count,
        duration: 2600
      }
    })], 1)])])], 1);
  }), 1), _c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v(" Dispatch ")]), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, _vm._l(_vm.dispatchStatus, function (status) {
    return _c("el-col", {
      key: status.status,
      staticClass: "card-panel-col",
      attrs: {
        xs: 12,
        sm: 6,
        lg: 4
      }
    }, [_c("router-link", {
      attrs: {
        to: "/orders-dispatches/list?status=" + status.status + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
      }
    }, [_c("div", {
      staticClass: "card-panel"
    }, [_c("div", {
      staticClass: "card-panel-description"
    }, [_c("div", {
      staticClass: "card-panel-text"
    }, [_vm._v(" " + _vm._s(status.status) + " ")]), _c("count-to", {
      staticClass: "card-panel-num",
      attrs: {
        "start-val": 0,
        "end-val": status.count,
        duration: 2600
      }
    })], 1)])])], 1);
  }), 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 8,
      sm: 8,
      lg: 6
    }
  }, [[_c("router-link", {
    attrs: {
      to: "/dealers/list" + (_vm.branchId ? "?branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-people"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "peoples"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_vm._v(" Dealers ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.dealerCount,
      duration: 2600
    }
  })], 1)])])]], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };